import * as actionTypes from './actiontypes';
import { PAGE_LOADING, PAGE_LOADED } from '../page_details/actiontypes';
import * as API from './api';
import { log, showMessage } from '../../config/utils';

export const updateChatlogState = (payload, path) => {
    return {
        type: actionTypes.UPDATE_CHATLOG_STATE,
        payload,
        path
    };
}

export const getMessageTimeSeries = (payload, callback) => {
    return dispatch => {
        dispatch({
            type: actionTypes.MESSAGE_TIME_SERIES_LOADING,
        });

        API.getMessageTimeSeries(payload, (error, response) => {
            log('get message time series response:', response);
            if (callback) callback(response);
            if (!error) {
                dispatch({
                    type: actionTypes.MESSAGE_TIME_SERIES_RECEIVED,
                    payload: response,
                });
            } else {
                dispatch({
                    type: actionTypes.MESSAGE_TIME_SERIES_LOAD_ERROR,
                });
            }
        });
    };
}

export const getTrainingMessages = (payload, callback) => {
    return dispatch => {
        dispatch({
            type: actionTypes.TRAINING_MESSAGE_LOADING,
        });

        API.getTrainingMessages(payload, (error, response) => {
            log('get training messages response:', response)
            if (callback) callback();
            if (!error && response && response.data && response.data.chatThreads) {
                dispatch({
                    type: actionTypes.TRAINING_MESSAGE_LOAD_SUCCESS,
                    payload: response.data,
                });
            } else {
                dispatch({
                    type: actionTypes.TRAINING_MESSAGE_LOAD_ERROR,
                });
            }
        });
    };
}

export const getTrainingMessageSuggestions = (payload, callback) => {
    return dispatch => {
        dispatch({
            type: PAGE_LOADING,
            payload: "suggestions loading"
        });
        API.getTrainingMessageSuggestions(payload, (error, response) => {
            log('training msg suggestions response', response);
            dispatch({
                type: PAGE_LOADED,
            });
            if (!error && callback && response && response.data) {
                if (response.data.suggestions && response.data.text && response.data.text === payload.text) {
                    callback(response.data.suggestions);
                } else {
                    showMessage('error', 'invalid suggestion received');
                }
            }
        });
    };
}

export const trainMessage = (payload, callback) => {
    return dispatch => {
        dispatch({
            type: actionTypes.MESSAGE_TRAINING_START,
        });

        API.TrainMessage(payload, (error, response) => {
            log('train message response:', response);
            dispatch({
                type: actionTypes.MESSAGE_TRAINING_END,
                payload: response.data,
            });
            if (!error && response && response.data && response.data.trainedMessage) {
                dispatch({
                    type: actionTypes.MESSAGE_TRAINING_SUCCESS,
                    payload: response.data,
                    isTrained: payload.isTrained
                });
                if (callback) callback();
                showMessage('success', `"${response.data.trainedMessage.text}" has been successfully trained`);
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/data/redux/chatlog_details/actions.js